import { render, staticRenderFns } from "./Appshell.vue?vue&type=template&id=484649a4&"
import script from "./Appshell.vue?vue&type=script&lang=js&"
export * from "./Appshell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports